module.exports = __webpack_public_path__ + "assets/images/project/user.svg?v=bb284e88";